import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { ToastrModule } from 'ng6-toastr-notifications';

import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';

import {NgxMaskModule} from 'ngx-mask'
import { ClipboardModule } from 'ngx-clipboard';

import {FileUploadModule} from "ng2-file-upload/file-upload/file-upload.module";

import {AutocompleteLibModule} from 'angular-ng-autocomplete';


const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { AuthguardGuard } from './authguard.guard';
import { WaitinglistComponent } from './views/waitinglist/waitinglist.component';
import { ReceptionComponent } from './views/reception/reception.component';
import { WorkflowComponent } from './views/workflow/workflow.component';
import { TaxclientComponent } from './views/taxclient/taxclient.component';
import { FaxlogComponent } from './views/faxlog/faxlog.component';
import { UserComponent } from './views/user/user.component';
import { SecurityComponent } from './views/security/security.component';
import { ImmigrationComponent } from './views/immigration/immigration.component';


@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    HttpModule,
    HttpClientModule,
    FormsModule,
    ModalModule.forRoot(),
    NgxMaskModule.forRoot(),
    FileUploadModule,
    ClipboardModule,
    AutocompleteLibModule
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    LoginComponent,
    RegisterComponent,
    WaitinglistComponent,
    ReceptionComponent,
    WorkflowComponent,
    TaxclientComponent,
    FaxlogComponent,
    UserComponent,
    SecurityComponent,
    ImmigrationComponent
  ],
  providers: [{
    provide: LocationStrategy,
    useClass: HashLocationStrategy
  },AuthguardGuard],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
